import * as React from 'react'

import type { SVGProps } from 'react'

const SvgGelIconArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    stroke="currentColor"
    fill="currentColor"
    strokeWidth={0}
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M12.6 26.7 23.2 16 12.6 5.3H8.8v21.4h3.8z" stroke="none" />
  </svg>
)

export default SvgGelIconArrowRight
